export const CONSENT_COOKIE = 'op-consent';
export const CONSENT_VERSION = 1;

export interface ConsentChoice { analytics: boolean; marketing: boolean; }
export interface ConsentRecord { v: number; analytics: boolean; marketing: boolean; ts: number; }

export function parseConsent(raw: string | undefined | null): ConsentRecord | null {
  if (!raw) return null;
  try {
    const o = JSON.parse(raw);
    if (typeof o !== 'object' || o === null) return null;
    return { v: Number(o.v), analytics: !!o.analytics, marketing: !!o.marketing, ts: Number(o.ts) };
  } catch { return null; }
}

export function serializeConsent(choice: ConsentChoice): string {
  const rec: ConsentRecord = { v: CONSENT_VERSION, analytics: !!choice.analytics, marketing: !!choice.marketing, ts: Date.now() };
  return JSON.stringify(rec);
}

/** Banner shows when there is no record or it predates the current consent version. */
export function shouldShowBanner(record: ConsentRecord | null): boolean {
  return !record || record.v !== CONSENT_VERSION;
}

type Signal = 'granted' | 'denied';
/** Map our category choice to Google Consent Mode v2 signals. */
export function consentModeUpdate(choice: ConsentChoice): Record<string, Signal> {
  const a: Signal = choice.analytics ? 'granted' : 'denied';
  const m: Signal = choice.marketing ? 'granted' : 'denied';
  return { analytics_storage: a, ad_storage: m, ad_user_data: m, ad_personalization: m };
}
